import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef, HostListener, AfterViewInit  } from '@angular/core';

import { ContaService } from '../../shared/services/conta/conta.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

import { Conta } from '../../shared/models/conta';
import { IConta } from '../../shared/interfaces/conta.interface';

import { Cartao } from '../../shared/models/cartao';
import { ICartao } from '../../shared/interfaces/cartao.interface';

import { Cedente } from '../../shared/models/cedente';
import { ICedente } from '../../shared/interfaces/cedente.interface';

import { Adquirente } from '../../shared/models/adquirente';
import { IAdquirente } from '../../shared/interfaces/adquirente.interface';

import { contaStrings, adquirenteStrings } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';

import { SituacaoContaEnum } from '../../shared/enums/SituacaoConta.enum';

declare var $: any;

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})
export class SetupComponent implements OnInit, AfterViewInit {
  public contaId = '';
  public contaIdCartao = contaStrings.contaId;

  public img = null;
  public file = null;

  public sections: any[] = [];
  public indexPage = 1;
  public sectionPrefix = 'secao';

  public cartaoValidadeMes = '';
  public cartaoValidadeAno = '';

  public gatewayId = '';
  public gatewayKey = '';

  public loaded = false;
  public isOutline = true;
  public isFinished = false;
  public skipFirstForm = true;
  public skipSecondForm = true;
  public hasOneNotEmpty = false;

  public conta: IConta = new Conta();
  public cartao: ICartao = new Cartao();
  public cedente: ICedente = new Cedente();
  public adquirente: IAdquirente = new Adquirente();

  public regexArr: any = [
    { Name: 'JCB', regex: /^35\d?/ },
    { Name: 'Visa', regex: /^4\d{5}?/ },
    { Name: 'Aura', regex: /^50\d{2}?/ },
    { Name: 'Amex', regex: /^(34|37)\d?/ },
    { Name: 'Master', regex: /^5[1-5]\d?/ },
    { Name: 'Elo', regex: /^(5090|636|504|506)\d?/ },
    { Name: 'Discover', regex: /^(6011|622|64|65)\d?/ },
    { Name: 'Diners', regex: /^(301|305|36\d{3}?|38)\d?/ }
  ];

  public bancos: any[] = [
    { name: 'Bradesco', number: '237' },
    { name: 'Santander', number: '033' }
  ];

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private contaService: ContaService,
    private localStorage: LocalStorageService
  ) { }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    const EnterKey = 13;
    if (event.keyCode === EnterKey) { this.nextSection(); }
  }

  ngOnInit() {
    this.setTitle();
    this.getContaById();
    this.cedente.Banco = '033';
  }

  ngAfterViewInit() {
    const self = this;
    setTimeout(function() {
      self.setNumberOfSections();
      self.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Pular';
      self.elRef.nativeElement.querySelector('#icone-top').classList.add('secao-ativa-' + self.indexPage);
    }, 1500);
  }

  setTitle() {
    this.title.setTitle('Pague.lá | Setup');
  }

  setNumberOfSections() {
    const divs = document.getElementsByTagName('div');
    for (let x = 0; x < divs.length; x++) {
      if (this.isSection(divs[x])) { this.sections.push(divs[x]); }
    }
  }

  isSection(e) {
    return (' ' + e.className + ' ').indexOf(this.sectionPrefix) > -1 ? true : false;
  }

  changePage(e) {
    e.target.getAttribute('data-index') > this.indexPage ? this.nextSection() : this.previousSection();
  }

  verifyEmptyInputs() {
    const element = this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + this.indexPage);
    const inputs = element.querySelectorAll('input');

    let hasOneNotEmpty = false;

    if (this.indexPage === 2 && this.skipFirstForm) {
      return true;
    }

    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value) {
        hasOneNotEmpty = true;
      }
    }

    this.hasOneNotEmpty = hasOneNotEmpty;

    return this.hasOneNotEmpty;
  }

  isInputsEmpty(indexPage) {
    let isEmpty = false;
    const element = this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + indexPage);
    const inputs = element.querySelectorAll('input');

    if (!this.verifyEmptyInputs()) {
      return false;
    }

    for (let i = 0; i < inputs.length; i++) {
      if (!inputs[i].value) {
        inputs[i].parentNode.classList.add('has-error');
        isEmpty = true;
      } else {
        if (inputs[i].getAttribute('name') === 'CartaoValidadeMes') {
          if (inputs[i].value < '01' || inputs[i].value > '12') {
            inputs[i].parentNode.classList.add('has-error');
            isEmpty = true;
          }
        }

        if (inputs[i].getAttribute('name') === 'CartaoValidadeAno') {
          if (inputs[i].value < '18' || inputs[i].value > '99') {
            inputs[i].parentNode.classList.add('has-error');
            isEmpty = true;
          }
        }
      }
    }

    return isEmpty;
  }

  changeInput(e) {
    const element = this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + this.indexPage);
    const inputs = element.querySelectorAll('input');

    if (e.target.value) {
      e.target.parentNode.classList.remove('has-error');
    }

    if (!this.verifyEmptyInputs()) {
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].parentNode.classList.remove('has-error');
      }

      if (this.indexPage === 1) {
        document.querySelector('.btn-next button').innerHTML = 'Pular';
        this.isOutline = true;
        this.skipFirstForm = true;
      }

      if (this.indexPage === 2) {
        document.querySelector('.btn-next button').innerHTML = 'Pular';
        this.isOutline = true;
        this.skipSecondForm = true;
      }
    } else {
      if (this.indexPage === 1) {
        document.querySelector('.btn-next button').innerHTML = 'Avançar';
        this.isOutline = false;
        this.skipFirstForm = false;
      }

      if (this.indexPage === 2) {
        document.querySelector('.btn-next button').innerHTML = 'Avançar';
        this.isOutline = false;
        this.skipSecondForm = false;
      }

      this.nextInput(e);
    }
  }

  nextInput(e) {
    const elValue = e.target.value.replace(/ /g, '');
    switch (e.target.id) {
      case 'inputNumeroCartao':
        if (elValue.length === 16) { document.getElementById('inputValidadeMesCartao').focus(); }
        break;
      case 'inputValidadeMesCartao':
        if (elValue < '1' || elValue > '12') { e.target.parentNode.classList.add('has-error'); }
        if (elValue.length === 2) { document.getElementById('inputValidadeAnoCartao').focus(); }
        break;
      case 'inputValidadeAnoCartao':
        if (elValue < '18' || elValue > '99') { e.target.parentNode.classList.add('has-error'); }
        if (elValue.length === 2) { document.getElementById('inputCodSegurancaCartao').focus(); }
        break;
      case 'inputCodSegurancaCartao':
        if (elValue.length === 3) { document.getElementById('inputNomeTitularCartao').focus(); }
        break;
    }
  }

  nextSection() {
    const element = document.querySelector('body');
    const inputs: any = element.querySelectorAll('input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].parentNode.classList.remove('has-error');
    }

    if (this.isInputsEmpty(this.indexPage)) {
      return;
    }

    if (this.indexPage === this.sections.length - 1 && !this.isFinished) {
      this.submit();
      return;
    }

    if (this.indexPage === this.sections.length && this.isFinished) {
      const user = this.localStorage.get('user');

      if (user) {
        this.router.navigate(['painel']);
        return;
      } else {
        this.router.navigate(['login']);
        return;
      }
    }

    this.elRef.nativeElement.querySelector('#icone-top').classList.remove('secao-ativa-' + (this.indexPage));
    this.elRef.nativeElement.querySelector('#icone-top').classList.add('secao-ativa-' + (this.indexPage + 1));

    const self = this;
    $('.' + this.sectionPrefix + '-' + this.indexPage).animate({ 'left': '-=500px' }, function() {
      $('.' + self.sectionPrefix + '-' + (self.indexPage + 1)).css('left', '+500px').show();
      $('.' + self.sectionPrefix + '-' + (self.indexPage + 1)).animate({ 'left': '0px' });
      $(this).hide();

      $('.' + self.sectionPrefix + '-' + self.indexPage).find('.form-group').removeClass('has-error');

      self.indexPage++;

      const points = document.getElementsByClassName('ponto');
      for (let x = 0; x < points.length; x++) {
        points[x].classList.remove('ativo');
        if (points[x].getAttribute('data-index') === self.indexPage.toString()) {
          points[x].classList.add('ativo');
        }
      }
    });

    if (this.indexPage + 1 === this.sections.length) {
      $('.btn-next').animate({ 'left': '0px' });
      $('.btn-back').animate({ 'left': '-0px' });
    } else {
      $('.btn-next').animate({ 'left': '200px' });
      $('.btn-back').animate({ 'left': '-214px' });
    }

    if (this.indexPage + 1 === this.sections.length) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Entrar';
    } else if (this.indexPage + 1 === 2 && !this.skipFirstForm) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Pular';
      this.isOutline = true;
    } else {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Avançar';
      this.isOutline = false;
    }

    if (this.indexPage + 1 === 2 && !this.skipSecondForm) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Avançar';
      this.isOutline = false;
    }

    if (this.indexPage + 1 === 3) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Concluir';
      this.isOutline = false;
    }
  }

  previousSection() {
    if ((this.indexPage - 1) === 1 && this.skipFirstForm) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Pular';
      this.isOutline = true;
    } else if ((this.indexPage - 1) === 2 && this.skipSecondForm) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Pular';
      this.isOutline = true;
    } else {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Avançar';
      this.isOutline = false;
    }

    this.elRef.nativeElement.querySelector('#icone-top').classList.remove('secao-ativa-' + (this.indexPage));
    this.elRef.nativeElement.querySelector('#icone-top').classList.add('secao-ativa-' + (this.indexPage - 1));

    if (this.indexPage !== 1) {
      const self = this;
      $('.' + this.sectionPrefix + '-' + this.indexPage).animate({ 'left': '+=500px' }, function() {
        $('.' + self.sectionPrefix + '-' + (self.indexPage - 1)).css('left', '-500px').show();
        $('.' + self.sectionPrefix + '-' + (self.indexPage - 1)).animate({ 'left': '0px' });
        $(this).hide();

        self.indexPage--;

        const points = document.getElementsByClassName('ponto');
        for (let x = 0; x < points.length; x++) {
          points[x].classList.remove('ativo');
          if (points[x].getAttribute('data-index') === self.indexPage.toString()) {
            points[x].classList.add('ativo');
          }
        }
      });

      if (this.indexPage - 1 === 1) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
      } else {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-214px' });
      }
    }
  }

  submit() {
    this.enableLoading();

    this.adquirente.Padrao = true;
    this.adquirente.GatewayId = this.gatewayId;
    this.adquirente.GatewayKey = this.gatewayKey;
    this.adquirente.TipoMeioPagamento = adquirenteStrings.tipoMeioPagamento;

    this.cartao.DataValidade = this.cartaoValidadeMes + '/20' + this.cartaoValidadeAno;

    this.cedente.Padrao = true;
    this.cedente.Banco = this.elRef.nativeElement.querySelector('#banco').value;

    if (this.conta.Cartoes.length === 0) { this.conta.Cartoes.push(this.cartao); }
    if (this.conta.Cedentes.length === 0) { this.conta.Cedentes.push(this.cedente); }
    if (this.conta.Adquirentes.length === 0) { this.conta.Adquirentes.push(this.adquirente); }

    this.conta.TipoCadastro = 'Gateway';
    this.conta.Situacao = Number(SituacaoContaEnum.Ativa);

    this.contaService.atualizarConta(this.conta).subscribe((data) => {
      this.disableLoading();
      this.isFinished = true;

      this.elRef.nativeElement.querySelector('#icone-top').style.opacity = '0';
      this.elRef.nativeElement.querySelector('.navegacao').style.opacity = '0';

      this.nextSection();
    }, (err) => {
      this.disableLoading();
      console.error(err);
    });
  }

  getContaById() {
    if (this.route.snapshot.params['contaId']) {
      this.contaId = this.route.snapshot.params['contaId'];
      this.contaService.obterConta(this.contaId).subscribe((data: any) => {
        this.conta = data;
        this.loaded = true;

        if (this.isSetupCompleted(data)) { this.router.navigate(['login']); }
      }, (err) => {
        console.error(err);
        this.router.navigate(['404']).then();
      });
    }
  }

  isSetupCompleted(data) {
    return data.Adquirentes && data.Adquirentes.length > 0 ? true : false ;
  }

  getBandeiraCartao(): string  {
    let name = '';
    this.regexArr.forEach((r, i) => {
      if (r.regex.test(this.cartao.Numero)) {
        name = r.Name;
      }
    });
    return name;
  }

  setBandeira(e) {
    this.cartao.Bandeira = e.name;
  }

  changeBanco(e) {
    this.cedente.Banco = e.target.value;
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/setup/setup.component.ts